export enum LockPointEnum {
    none = -1,
    topLeft = 0,
    topRight = 1,
    bottomLeft = 2,
    bottomRight = 3
}
